import React, { useEffect, useState } from 'react'
import { isNullUndefined } from '@/main/services/utils';
import { saveQueryParams, useQueryParamsReducer } from '@/main/store/queryParams';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

interface IQueryParamsChildrenProps {
  customName?: string;
  initialQueryParams?: { [key: string]: string };
  validateQueryParams?: { [key: string]: string };
}

function QueryParamsChildren({
  customName,
  initialQueryParams,
  validateQueryParams,
  children
}: React.PropsWithChildren<IQueryParamsChildrenProps>) {
  const location = useLocation();
  const nameSave = isNullUndefined(customName) ? location.pathname : `${location.pathname}_${customName}`
  const dispatch = useDispatch();
  const { queryParams: queryParamsReducer } = useQueryParamsReducer();
  const [isCheckedQueryParams, setIsCheckedQueryParams] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();

  function isValidQueryParams(queryParamsValues: { [key: string]: string }) {
    const haveValidateQueryParams = !isNullUndefined(validateQueryParams);
    const isEmptyQueryParams = Object.keys(queryParamsValues).length === 0;
    if (!haveValidateQueryParams || isEmptyQueryParams) return true;
    const keysQueryParams = Object.keys(queryParamsValues);
    const keysValidateQueryParams = Object.keys(validateQueryParams);
    const urlHaveAllKeys = keysValidateQueryParams.every(key => keysQueryParams.includes(key) && queryParamsValues[key] == validateQueryParams[key])

    return urlHaveAllKeys;
  }
  useEffect(() => {
    setIsCheckedQueryParams(true)
    const haveQueryParamsUrl = searchParams.toString().length > 0
    if (haveQueryParamsUrl || isNullUndefined(queryParamsReducer.data)) return;
    const haveInitialQueryParams = !isNullUndefined(initialQueryParams);
    const haveStorageQueryParams = queryParamsReducer.data[nameSave]

    if (haveStorageQueryParams) {
      const queryParamsString = new URLSearchParams(queryParamsReducer.data[nameSave])
      setSearchParams(queryParamsString, { replace: true })
      return;
    }
    if (haveInitialQueryParams) {
      const queryParamsString = new URLSearchParams(initialQueryParams)
      setSearchParams(queryParamsString, { replace: true })
    }
  }, [nameSave])

  useEffect(() => {
    const searchParamsObject = Object.fromEntries(searchParams.entries());
    const isValidToSave = isValidQueryParams(searchParamsObject)
    if (!isValidToSave) return;
    dispatch(saveQueryParams(searchParamsObject, nameSave));
  }, [searchParams])

  if (!isCheckedQueryParams) {
    return null
  }

  return <>{children}</>;
}

export function withQueryparams<T extends React.PropsWithChildren<{}>>(WrappedComponent: React.ComponentType<T>, propsQueryParams?: IQueryParamsChildrenProps) {
  return function WithQueryParamsComponent(props: T) {
    return (
      <QueryParamsChildren {...propsQueryParams}>
        <WrappedComponent {...props} />
      </QueryParamsChildren>
    );
  };
}
